import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

/**
 * 帮助获取ref
 * https://github.com/facebook/react/issues/11401#issuecomment-340543801.
 * 例如：
 * ```jsx
 * import React from 'react';
 * import RootRef from '@material-ui/core/RootRef';
 *
 * class MyComponent extends React.Component {
 *   constructor() {
 *     super();
 *     this.domRef = React.createRef();
 *   }
 *
 *   componentDidMount() {
 *     console.log(this.domRef.current); // DOM node
 *   }
 *
 *   render() {
 *     return (
 *       <RootRef rootRef={this.domRef}>
 *         <SomeChildComponent />
 *       </RootRef>
 *     );
 *   }
 * }
 * ```
 */
class RootRef extends React.Component {
  componentDidMount() {
    const { rootRef } = this.props;
    this.ref = ReactDOM.findDOMNode(this);
    setRef(rootRef, this.ref);
  }

  componentDidUpdate(prevProps) {
    const { rootRef } = this.props;
    const ref = ReactDOM.findDOMNode(this);

    if (prevProps.rootRef !== rootRef || this.ref !== ref) {
      if (prevProps.rootRef !== rootRef) {
        setRef(prevProps.rootRef, null);
      }

      this.ref = ref;
      setRef(rootRef, this.ref);
    }
  }

  componentWillUnmount() {
    const { rootRef } = this.props;
    this.ref = null;
    setRef(rootRef, null);
  }

  render() {
    const { children } = this.props;
    return children;
  }
}

RootRef.propTypes = {
  /**
   * The wrapped element.
   */
  children: PropTypes.element.isRequired,
  /**
   * Provide a way to access the DOM node of the wrapped element.
   * You can provide a callback ref or a `React.createRef()` ref.
   */
  rootRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
};

export default RootRef;



// WEBPACK FOOTER //
// ./src/rootRef/RootRef.jsx